import { Flex, Spinner } from "@chakra-ui/react";
import { Icon } from "assets/Icon";
import Tooltip from "components/Tooltip";
import { Button } from "newui/components/Button";

interface ContinueButtonProps {
	onClick: () => void;
	disabled: boolean;
	lastStep: boolean;
	isSubmittingForm?: boolean;
	isValidating?: boolean;
	isTemplate?: boolean;
	showIgnoreApproversButton: boolean;
}

const ContinueButton = ({
	onClick,
	disabled,
	lastStep,
	isSubmittingForm,
	isValidating,
	isTemplate,
	showIgnoreApproversButton,
}: ContinueButtonProps) => {
	return (
		<Tooltip
			label={
				disabled &&
				lastStep &&
				`You cannot ${isTemplate ? "save this template" : "send this RFx"} yet - please check all tabs have been completed correctly.`
			}
		>
			<Button
				disabled={disabled}
				btntype={"primary"}
				type="button"
				onClick={onClick}
			>
				{showIgnoreApproversButton && lastStep ? (
					<Flex
						gap={2}
						align={"center"}
					>
						{"Awaiting Approval - click to override and submit"}
						<Icon
							iconClassName={
								disabled ? "text-bg-gray-200" : "text-bg-brand-solid"
							}
							icon={"check-circle"}
						/>
					</Flex>
				) : isSubmittingForm || isValidating ? (
					<Spinner />
				) : lastStep ? (
					isTemplate ? (
						"Save Template"
					) : (
						"Send RFx"
					)
				) : (
					"Continue"
				)}
			</Button>
		</Tooltip>
	);
};

export default ContinueButton;
